import { Form } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { TextInput } from "../../../../components/Input/TextInput.tsx"
import { NAME_MAX_LENGTH as NAME_MAX } from "../../helpers/copy-name"
import type { AutomationFormValues } from "../../helpers/form-values"
import type { AutomationOptions } from "../../types/automation.types"
import { CategoryChoice } from "../CategoryChoice"
import { ChannelChoice } from "../ChannelChoice"
import { BuilderSection } from "./BuilderSection"

export function BasicsSection({
  options,
  complete
}: {
  options: AutomationOptions
  complete: boolean
}) {
  const { t } = useTranslation()
  return (
    <BuilderSection sectionKey={"basics"} complete={complete}>
      <Form.Item<AutomationFormValues>
        label={t("settingsAutomation.builder.basics.nameLabel")}
        name={"name"}
        rules={[
          {
            required: true,
            whitespace: true,
            message: t("settingsAutomation.builder.basics.nameRequired")
          },
          { max: NAME_MAX, message: t("settingsAutomation.builder.basics.nameMax", { max: NAME_MAX }) }
        ]}
      >
        <TextInput
          placeholder={t("settingsAutomation.builder.basics.namePlaceholder")}
          maxLength={NAME_MAX}
        />
      </Form.Item>

      <Form.Item<AutomationFormValues>
        label={t("settingsAutomation.builder.basics.channelLabel")}
        name={"channel"}
      >
        <ChannelChoice channels={options.channels} />
      </Form.Item>

      <Form.Item<AutomationFormValues>
        label={t("settingsAutomation.builder.basics.categoryLabel")}
        name={"category"}
        className={"mb-0"}
      >
        <CategoryChoice />
      </Form.Item>
    </BuilderSection>
  )
}
